// when given a spacing amount, how should we interpret it?
// "SpaceBetween" means "not on-center".

// TODO: add 'on-center' spacing
// these functions could benefit (see map() usage):
// - generateGridHorizontalLinesForShape
// - generateGridVerticalLinesForShape
// - generateHatChannelsGeometry
// - generateStandardPicketsSection
export enum ObjectSpacingMethod {
  MinimumSpaceBetween = 'minimum-space-between',
  MaximumSpaceBetween = 'maximum-space-between',
  FixedSpaceFromStart = 'fixed-space-from-start',
}
